import { setupBlock } from "./setup-block";
import { terrainTypes, TerrainCodes } from "./terrain-types";

import type { Config } from "./config";
const PLANE_WIDTH = 1200;
const PLANE_HEIGHT = 690;

export const config: Config = {
    planeData: "data/wheatbelt_v2.json",
    scale: 1,
    backgroundImage: "images/zones-roads-textured.png",
    backgroundColor: "#d69061",
    buildings: [
        {
            x: Math.floor(PLANE_WIDTH / 2),
            y: Math.floor(PLANE_HEIGHT / 2),
            width: PLANE_WIDTH,
            height: PLANE_HEIGHT,
            src: "images/buildings.png",
            terrainType: terrainTypes[TerrainCodes.House],
        },
    ],
    roads: [],
    trees: [
        {
            x: Math.floor(PLANE_WIDTH / 2),
            y: Math.floor(PLANE_HEIGHT / 2),
            width: PLANE_WIDTH,
            height: PLANE_HEIGHT,
            src: "images/trees.png",
            terrainType: terrainTypes[TerrainCodes.ForestHigh],
        },
    ],
    terrain: [
        {
            x: Math.floor(PLANE_WIDTH / 2),
            y: Math.floor(PLANE_HEIGHT / 2),
            width: PLANE_WIDTH ,
            height: PLANE_HEIGHT,
            src: "images/water.png",
            terrainType: terrainTypes[TerrainCodes.Water],
        },
        {
            x: Math.floor(PLANE_WIDTH / 2),
            y: Math.floor(PLANE_HEIGHT / 2),
            width: PLANE_WIDTH,
            height: PLANE_HEIGHT,
            src: "images/ovals.png",
            terrainType: terrainTypes[TerrainCodes.Dirt],
        },
    ],
};

setupBlock(config);
